import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconCheckboxSelect = props => (
  <SvgIcon {...props} viewBox="0 0 18 18">
    <path d="m16 2v14h-14v-14h14zm0-2h-14c-1.1 0-2 0.9-2 2v14c0 1.1 0.9 2 2 2h14c1.1 0 2-0.9 2-2v-14c0-1.1-0.9-2-2-2z" />
    <path d="m4 8h10v2h-10v-2z" />
    <path d="m10 4v10h-2v-10h2z" />
  </SvgIcon>
);

export default IconCheckboxSelect;



// WEBPACK FOOTER //
// ./src/components/icons/IconCheckboxSelect.js